import { APP_ENVIRONMENT_ENUM } from '@woovi/shared';
const isDev = process.env.NODE_ENV === APP_ENVIRONMENT_ENUM.DEVELOPMENT;

export const requiredFieldLogger = (event) => {
  if (!isDev) {
    return;
  }

  // eslint-disable-next-line
  console.log('RELAY required: ', event);
};
